import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import engagement from "../../../assets/images/engagement1.jpg";
import fishery from "../../../assets/images/fishery_2.jpg";
import research from "../../../assets/images/research.jpg";
import advocacy from "../../../assets/projects/nip_7.jpg";
import training from "../../../assets/images/training.JPG";
import seaweed from "../../../assets/images/seaweed_2.jpg";

const Core = () => {
  return (
    <Box margin={{ xs: "20% 0%", sm: "3% 0%" }}>
      <Box paddingBottom={{ xs: "10%", sm: "3%" }}>
        <Typography
          variant="h6"
          color="#9DCC49"
          fontWeight={800}
          paddingTop={"4%"}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Box component={"span"}>
            <WaterIcon
              sx={{
                width: 23,
                height: 23,
              }}
            />
          </Box>{" "}
          Our Core Areas
        </Typography>
        <Typography
          variant="h3"
          color="#317ABE"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          Together, let's echo the call for a sustainable blue future.
        </Typography>
      </Box>
      <Grid container>
        <Grid item xs={12} sm={6.5} margin={{ xs: "25% 0% 0% 0%", sm: "0%" }}>
          <Box
            component="img"
            height={{ xs: "28vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={engagement}
            alt={"Fishery"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={5.5}
          padding={{ xs: "8% 0%", sm: "0%" }}
          marginTop={{ xs: "0%", sm: "4%" }}
          marginBottom={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "2% 0%", sm: "4% 6% 3% 6%" }}
          >
            Blue Economy Enhancement
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "1% 0%", sm: "0% 6%" }}
            lineHeight={1.5}
          >
            Underserved communities are often overlooked, yet they are endowed
            with abundant natural resources ready to be harnessed. We aim to
            leverage both freshwater and marine resources to drive economic
            growth. The foundation’s initiatives are rooted in conservation and
            sustainable use. Currently, Africa contributes only about 1.9% to
            global aquaculture production, in contrast to Asia’s 91%. Our focus
            is to establish a sustainable pathway to provide affordable protein
            alternatives.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "2% 6%" }}
            lineHeight={1.5}
          >
            The Genetically Improved Farmed Tilapia (GIFT) initiative is a prime
            example of this mission, as it enhances food security by improving
            the genetic quality of farmed tilapia, producing faster-growing,
            nutrient-rich fish that are both affordable and accessible.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "2% 6%" }}
            lineHeight={1.5}
          >
            GIFT tilapia farming addresses protein deficiencies among vulnerable
            populations while promoting responsible aquaculture practices.
            Aligned with the blue economy principles, the foundation empowers
            local communities to earn a stable income, strengthens regional food
            systems, and supports sustainable resource management.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={5.5}
          marginTop={{ xs: "25%", sm: "7%" }}
          display={{ xs: "block", sm: "none" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "400px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={seaweed}
            alt={"seaweed"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          marginTop={{ xs: "10%", sm: "2%" }}
          marginBottom={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "2% 0%", sm: "0% 0% 3% 0%" }}
          >
            Marine Flora & Fauna Protection Advocacy
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "0% 0%", sm: "0% 6% 3% 0%" }}
            lineHeight={1.5}
          >
            Blue Echo Foundation is driving a high-impact blue economy
            initiative to strengthen Nigeria’s coastal communities by protecting
            and sustainably managing ocean flora and fauna. Through
            science-based advocacy, community engagement, and policy support, we
            promote resilient marine ecosystems as the foundation for inclusive
            coastal prosperity.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "3% 0%", sm: "0% 6% 2% 0%" }}
            lineHeight={1.5}
          >
            Aligned with the global 30x30 target, that is, protecting at least
            30% of the world’s oceans by 2030, our advocacy supports measurable
            conservation outcomes that secure marine biodiversity, enhance
            climate resilience, and sustain ocean-dependent economies.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 1% 0%" }}
            lineHeight={1.5}
          >
            <strong>&#10033; Marine Protected Areas (MPAs): </strong> We support
            the designation, strengthening, and effective management of MPAs to
            conserve ecologically sensitive habitats.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 1% 0%" }}
            lineHeight={1.5}
          >
            <strong>&#10033; Plastic Pollution Reduction: </strong>We promote
            circular economy solutions and policy reforms to reduce single-use
            plastics and strengthen coastal waste management systems.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 1% 0%" }}
            lineHeight={1.5}
          >
            <strong>&#10033; Marine Species Protection:</strong> We advocate for
            stronger enforcement of marine biodiversity protection frameworks
            and responsible fisheries practices.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 1% 0%" }}
            lineHeight={1.5}
          >
            <strong>&#10033; Blue Carbon Ecosystem Conservation: </strong> We
            champion the protection and restoration of mangroves, seagrass
            meadows, and other coastal blue carbon ecosystems.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={5.5}
          marginTop={{ xs: "20%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "50vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={seaweed}
            alt={"Seaweed"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6.5}
          marginTop={{ xs: "25%", sm: "7%" }}
          display={{ xs: "block", sm: "none" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "400px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={fishery}
            alt={"cage culture"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6.5}
          marginTop={{ xs: "20%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "50vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={fishery}
            alt={"cage culture"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={5.5} marginTop={{ xs: "10%", sm: "10%" }}>
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "2% 0%", sm: "0% 0% 3% 6%" }}
          >
            Climate Resilience
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "0% 0%", sm: "0% 6% 3% 6%" }}
            lineHeight={1.5}
          >
            The Foundation addresses climate change by developing strategies
            that help communities adapt to shifting environmental conditions,
            focusing on minimizing risks and supporting sustainable livelihoods.
            Cage culture is a central component of this effort. By deploying
            floating fish cages in local water bodies, this method maximizes
            production within a controlled, low-impact setup that safeguards the
            natural ecosystem.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "3% 0%", sm: "0% 6% 3% 6%" }}
            lineHeight={1.5}
          >
            Unlike traditional farming, cage culture minimizes land and resource
            use and relies on renewable energy sources, which reduces greenhouse
            gas emissions. The result is a resilient, scalable fish production
            system that not only meets local nutritional needs but also enhances
            climate resilience in communities heavily affected by climate
            variability.
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6.5}
          marginTop={{ xs: "25%", sm: "15%" }}
          display={{ xs: "block", sm: "none" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "600px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={training}
            alt={"training"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={5.5} marginTop={{ xs: "10%", sm: "15%" }}>
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "2% 0%", sm: "0% 6% 3% 0%" }}
          >
            Skilling-up Youths
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "1% 0%", sm: "0% 6% 0% 0%" }}
            lineHeight={1.5}
          >
            The Foundation recognizes that youth play a crucial role in
            sustainable development. Through specialized training programs, it
            equips young people with practical skills in aquaculture,
            entrepreneurship, and resource management, empowering them to
            achieve financial independence.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "2% 6% 2% 0%" }}
            lineHeight={1.5}
          >
            The Foundation’s youth development model includes technical
            education, mentorship, and access to necessary resources such as
            startup kits for aquaculture ventures. These programs cultivate
            self-sufficiency and support the next generation of environmental
            stewards, contributing to a sustainable workforce that can address
            future food security and environmental challenges.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6.5}
          marginTop={{ xs: "25%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={training}
            alt={"training"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6.5} marginTop={{ xs: "25%", sm: "0%" }}>
          <Box
            component="img"
            height={{ xs: "27vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={research}
            alt={"research_image"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={5.5} marginTop={{ xs: "3%", sm: "12%" }}>
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "4% 0%", sm: "0% 0% 3% 6%" }}
          >
            Research and Policy Innovation
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "1% 0%", sm: "0% 6% 3% 6%" }}
            lineHeight={1.5}
          >
            We spearheads research initiatives to explore sustainable practices
            in aquaculture, climate adaptation, and resource management. This
            research forms the basis of its policy advocacy efforts, which
            promote regulations that align with environmental sustainability and
            community welfare.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 3% 6%" }}
            lineHeight={1.5}
          >
            Blue-Echo collaborates with academic institutions, government
            bodies, and environmental organizations to identify and address
            pressing issues, like overfishing and habitat loss, while providing
            data-backed recommendations to policymakers. Through informed
            advocacy, the foundation works toward systemic changes that benefit
            both the environment and local communities in the long term.
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          marginTop={{ xs: "25%", sm: "14%" }}
          display={{ xs: "block", sm: "none" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "350px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={advocacy}
            alt={"Advocacy"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} marginTop={{ xs: "3%", sm: "15%" }}>
          <Typography
            variant={"h4"}
            fontWeight={700}
            textAlign={"left"}
            color={"#317ABE"}
            padding={{ xs: "4% 0%", sm: "0% 6% 3% 0%" }}
          >
            Downstream Partnerships
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0%", sm: "0% 6% 0% 0%" }}
            lineHeight={1.5}
          >
            By collaborating with local stakeholders—farmers, cooperatives,
            businesses, and governmental bodies—the foundation strengthens
            community resilience and economic viability. These partnerships
            facilitate knowledge-sharing, resource access, and market expansion,
            creating a supportive network for local businesses.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            padding={{ xs: "2% 0% 10% 0%", sm: "3% 6% 0% 0%" }}
            lineHeight={1.5}
          >
            The Foundation’s partnerships also improve supply chains, making
            them more robust and sustainable. This approach ensures that
            small-scale farmers and entrepreneurs have a reliable pathway to
            scale their operations, access fair markets, and contribute to the
            local economy, fostering sustainable growth from the ground up.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          marginTop={{ xs: "25%", sm: "0%" }}
          display={{ xs: "none", sm: "block" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "700px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={advocacy}
            alt={"Advocacy"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Core;
